import React  from "react";

const BlogsSection = ({language, title, blogs, button1,button2 }) => {


  const isArabic = language === "ar";
  const rtlClass = isArabic ? "rtl-style" : "";



  return (
    <div className={`container blog-section ${rtlClass}`}>
      <div className="row">
        <div className="col-md-4 col-12 position-relative">
          <h3 className="blog-section-title">{title}</h3>
        </div>
        {blogs.map((blog, index) => (
          <div key={index} className="col-md-4 col-12">
            <div className="d-flex flex-column">
              <img
                src={`/assets/images/Blogs/Blog-${index + 1}.${
                  index === 0 ? "png" : "jpg"
                }`}
                alt={`Blog-${index + 1}`}
              />
              <p className="text-center blog-body">
                <strong>{blog.caption}</strong>
              </p>
              <button
                className="Blog-button"
                onClick={() => (window.location.href = blog.link)}
              >
                {index === 0 ? button1 : button2}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogsSection;
